// extracted by mini-css-extract-plugin
export default {"wrapper":"NetworkConfigurationsNotes_wrapper__wJfAT","buttonsWrapper":"NetworkConfigurationsNotes_buttonsWrapper__9jlSy","textArea":"NetworkConfigurationsNotes_textArea__0heLT"};